<section class="profile-password" [formGroup]="form">

    <app-profile-section-header title="Cambio de contraseña" subtitle="Personaliza la contraseña">
        <svg headerIcon viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
            <rect x="3" y="5" width="18" height="14" rx="2"/>
            <path d="M3 7l9 6 9-6" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </app-profile-section-header>

    <div class="pp-form">

        <div class="pp-field">
            <label for="pp-actual">Contraseña actual</label>
            <div class="pp-input" [class.pp-input--error]="isInvalid('actual')">
                <input id="pp-actual" [type]="show.actual ? 'text' : 'password'"
                       formControlName="actual" maxlength="16" autocomplete="current-password">
                <button type="button" class="pp-input-eye" (click)="toggle('actual')"
                        [attr.aria-label]="show.actual ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                    <svg *ngIf="!show.actual" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
                        <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z" stroke-linejoin="round"/>
                        <circle cx="12" cy="12" r="3"/>
                    </svg>
                    <svg *ngIf="show.actual" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
                        <path d="M3 3l18 18" stroke-linecap="round"/>
                        <path d="M10.6 6.1A10.9 10.9 0 0 1 12 6c6 0 10 7 10 7a16 16 0 0 1-3 3.6M6.5 6.5A16 16 0 0 0 2 12s4 7 10 7c1.7 0 3.2-.3 4.5-.9" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
            <p *ngIf="isInvalid('actual')" class="pp-error">
                <ng-container *ngIf="form.get('actual').errors?.required">(*) Informe su contraseña actual</ng-container>
                <ng-container *ngIf="form.get('actual').errors?.pattern">(*) Formato no válido</ng-container>
            </p>
        </div>

        <div class="pp-field">
            <label for="pp-new">Nueva contraseña</label>
            <div class="pp-input" [class.pp-input--error]="isInvalid('new')">
                <input id="pp-new" [type]="show.new ? 'text' : 'password'"
                       formControlName="new" maxlength="16" autocomplete="new-password">
                <button type="button" class="pp-input-eye" (click)="toggle('new')"
                        [attr.aria-label]="show.new ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                    <svg *ngIf="!show.new" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
                        <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z" stroke-linejoin="round"/>
                        <circle cx="12" cy="12" r="3"/>
                    </svg>
                    <svg *ngIf="show.new" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
                        <path d="M3 3l18 18" stroke-linecap="round"/>
                        <path d="M10.6 6.1A10.9 10.9 0 0 1 12 6c6 0 10 7 10 7a16 16 0 0 1-3 3.6M6.5 6.5A16 16 0 0 0 2 12s4 7 10 7c1.7 0 3.2-.3 4.5-.9" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
            <p *ngIf="isInvalid('new')" class="pp-error">
                <ng-container *ngIf="form.get('new').errors?.required">(*) Informe una contraseña</ng-container>
                <ng-container *ngIf="form.get('new').errors?.pattern">(*) 8-16 caracteres con mayúscula, minúscula, número y símbolo</ng-container>
            </p>
        </div>

        <div class="pp-field">
            <label for="pp-confirmation">Confirmación contraseña</label>
            <div class="pp-input" [class.pp-input--error]="isInvalid('confirmation')">
                <input id="pp-confirmation" [type]="show.confirmation ? 'text' : 'password'"
                       formControlName="confirmation" maxlength="16" autocomplete="new-password">
                <button type="button" class="pp-input-eye" (click)="toggle('confirmation')"
                        [attr.aria-label]="show.confirmation ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                    <svg *ngIf="!show.confirmation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
                        <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z" stroke-linejoin="round"/>
                        <circle cx="12" cy="12" r="3"/>
                    </svg>
                    <svg *ngIf="show.confirmation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
                        <path d="M3 3l18 18" stroke-linecap="round"/>
                        <path d="M10.6 6.1A10.9 10.9 0 0 1 12 6c6 0 10 7 10 7a16 16 0 0 1-3 3.6M6.5 6.5A16 16 0 0 0 2 12s4 7 10 7c1.7 0 3.2-.3 4.5-.9" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
            <p *ngIf="isInvalid('confirmation')" class="pp-error">
                <ng-container *ngIf="form.get('confirmation').errors?.required">(*) Confirme su nueva contraseña</ng-container>
                <ng-container *ngIf="!form.get('confirmation').errors?.required && form.get('confirmation').errors?.isMatching === false">
                    (*) La contraseña debe ser la misma que la confirmación
                </ng-container>
                <ng-container *ngIf="form.get('confirmation').errors?.pattern">(*) Formato no válido</ng-container>
            </p>
        </div>

        <aside class="pp-tips">
            <h3 class="pp-tips-title">
                <span class="pp-tips-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                        <circle cx="12" cy="12" r="10"/>
                        <path d="M12 8v4M12 16h.01" stroke-linecap="round"/>
                    </svg>
                </span>
                Consejos de seguridad
            </h3>
            <ul>
                <li>Usa una combinación de letras mayúsculas, minúsculas, números y símbolos</li>
                <li>Cambia tu contraseña regularmente</li>
            </ul>
        </aside>

    </div>

    <div *ngIf="messages && messages.length" class="pp-messages">
        <p *ngFor="let m of messages">{{ m }}</p>
    </div>

    <div class="pp-actions">
        <button type="button" class="pp-save" (click)="save()" [disabled]="running">
            {{ getButtonLabel() }}
        </button>
    </div>
</section>
